export const DEFAULT_FIREBASE_AUTH_DOMAIN = "karango-a60c1.firebaseapp.com";

const APP_HOSTNAMES = new Set([
  "karango.fr",
  "www.karango.fr",
  "karango-a60c1.web.app",
]);

/**
 * Android opens OAuth outside an installed PWA. Keeping the callback on
 * karango.fr lets the PWA (whose scope is "/") capture /__/auth/handler and
 * strand the user on Firebase's blank helper page. The Firebase-owned domain
 * stays outside that scope and is safe for the popup flow.
 *
 * iOS and regular desktop browsers keep the app origin as authDomain so the
 * redirect helper remains first-party, per Firebase's redirect guidance.
 */
export function resolveFirebaseAuthDomain({ hostname = "", userAgent = "" } = {}) {
  const normalizedHostname = String(hostname || "").toLowerCase();
  const normalizedUserAgent = String(userAgent || "");

  if (/android/i.test(normalizedUserAgent)) {
    return DEFAULT_FIREBASE_AUTH_DOMAIN;
  }

  return APP_HOSTNAMES.has(normalizedHostname)
    ? normalizedHostname
    : DEFAULT_FIREBASE_AUTH_DOMAIN;
}

